<template>
  <v-card class="crud-dialog">
    <v-card-title class="headline">
      <v-icon>security</v-icon> Observar documento
      <v-btn icon @click.native="$store.commit('closeModal', 5)">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-layout row>
        <v-flex>
          <v-text-field
            label="Observacion"
            class="input-group--focused"
            maxlength="500"
            multi-line
            :counter="500"
            :rules="$validate(['required'])"
            v-model="observacion"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- observacion por revisores -->
      <v-btn @click.native="$store.commit('closeModal', 5)">
          <v-icon>cancel</v-icon> Cancelar
        </v-btn>
      <v-btn
        color="primary"
        v-if="$store.state.user.id_rol === 3"
        @click="actualizarEstadoTramiteDoc(solicitud, 'OBSERVADO_CANCILLERIA_REVISOR', observacion); $store.commit('closeModal', 5); $store.commit('closeModal', 2);">
        <v-icon left>warning</v-icon> Observar solicitud
      </v-btn>
      <v-btn
        color="primary"
        v-if="$store.state.user.id_rol === 6"
        @click="actualizarEstadoTramiteDoc(solicitud, 'OBSERVADO_ENTIDAD_REVISOR', observacion); $store.commit('closeModal', 5); $store.commit('closeModal', 2);">
        <v-icon left>warning</v-icon> Observar solicitud
      </v-btn>
      <!-- observacion por firmadores -->
      <v-btn
        color="primary"
        v-if="$store.state.user.id_rol === 4"
        @click="actualizarEstadoTramiteDoc(solicitud, 'OBSERVADO_CANCILLERIA_FIRMANTE', observacion); $store.commit('closeModal', 5); $store.commit('closeModal', 3);">
        <v-icon left>warning</v-icon> Observar solicitud
      </v-btn>
      <v-btn
        color="primary"
        v-if="$store.state.user.id_rol === 7"
        @click="actualizarEstadoTramiteDoc(solicitud, 'OBSERVADO_ENTIDAD_FIRMANTE', observacion); $store.commit('closeModal', 5); $store.commit('closeModal', 3);">
        <v-icon left>warning</v-icon> Observar solicitud
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import tramiteDoc from './mixins/tramite_doc';
import validate from '@/common/mixins/validate';

export default {
  mixins: [ tramiteDoc, validate ],
  data () {
    return {
      observacion: ''
    };
  },
  props: {
    solicitud: {
      type: Object,
      default: () => {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// Observar.vue?92113094